export default class Module {
  constructor (
    id, 
    description, 
    minimumProfiles,
    name, 
    userInterval, 
    pricePerUser, 
    profileInterval, 
    pricePerProfile, 
    permissionsIds
  ) {
    this.id = id
    this.description = description
    this.minimumProfiles = minimumProfiles
    this.name = name
    this.userInterval = userInterval
    this.pricePerUser = pricePerUser
    this.profileInterval = profileInterval
    this.pricePerProfile = pricePerProfile
    this.permissionsIds = permissionsIds
  }
}